import React from "react";
import { FormControl, FormHelperText, TextField } from "@mui/material";
import { Controller } from "react-hook-form";
// import "./style.css";
const TableInputField = ({
  sx,
  ref,
  focused,
  variant,
  defaultValue,
  inputProps,
  type,
  disabled,
  inputRef,
  name,
  label,
  error,
  onKeyDown,
  control,
  dontCapitalize,
  color,
  shrink,
  onBlurCapture,
  placeholder,
  id,
}) => {
  return (
    <FormControl fullWidth size="small" sx={sx}>
      <Controller
        render={({ field }) => (
          <fieldset disabled={disabled}>
            <TextField
              id={id}
              className="h-[28px] text-[14px] bg-white"
              inputRef={inputRef}
              ref={ref ? ref : null}
              autoComplete="off"
              onKeyDown={onKeyDown}
              onBlurCapture={onBlurCapture}
              inputProps={
                dontCapitalize
                  ? (inputProps,
                  {
                    style: {
                      fontSize: "14px",
                      height: "13px",
                    },
                  })
                  : (inputProps,
                  {
                    style: {
                      textTransform: "capitalize",
                      fontSize: "14px",
                      height: "13px",
                    },
                  })
              }
              sx={{
                ...sx,
                ...(shrink
                  ? {
                    "& .MuiFormLabel-root": {
                      fontSize: "14px",
                    },
                  }
                  : {
                    "& .MuiFormLabel-root": {
                      fontSize: "14px",
                      position: "absolute",
                      top: "-2px",
                    },
                    fontSize: "14px",
                  }),
                "& input[type=number]": {
                  "-moz-appearance": "textfield",
                },
                "& input[type=number]::-webkit-outer-spin-button, & input[type=number]::-webkit-inner-spin-button":
                {
                  "-webkit-appearance": "none",
                  margin: 0,
                },
              }}
              autoFocus={focused ? true : false}
              onWheel={(e) => {
                if (type == "number") {
                  e.target.blur();
                }
              }}
              type={type}
              error={!!error?.message}
              color={color}
              variant={variant}
              label={label}
              placeholder={placeholder ? placeholder : label}
              name={name}
              fullWidth
              {...field}
              size="small"
              shrink={false}
            />
          </fieldset>
        )}
        name={name}
        control={control}
        defaultValue={defaultValue}
      />
      {/* <FormHelperText style={{ color: "#d32f2f" }}>
        {error?.message}
      </FormHelperText> */}
    </FormControl>
  );
};

export default TableInputField;